import React, { FC, useState } from 'react';
import * as S from './styled';

export interface SwitchProps {
	onChange?: (value?: boolean) => void;
	checkedBackground?: string;
	background?: string;
	backgroundHover?: string;
	colorHover?: string;
	color?: string;
	checked?: boolean;
	name?: string;
	title?: string;
	fontWeight?: number;
	fontSize?: number;
	fontColor?: string;
}

export const Switch: FC<SwitchProps> = props => {
	const {
		onChange,
		checked,
		name = 'checkbox',
		title,
		fontColor,
		fontSize,
		fontWeight,
		background,
		color,
	} = props;

	const [state, setState] = useState(checked ?? false);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
		onChange?.(e.target.checked);
		setState(e.target.checked);
	};

	return (
		<>
			<S.Input
				type='checkbox'
				id={name}
				{...props}
				onChange={handleChange}
				checked={checked ?? state}
			/>
			<S.Label fontColor={fontColor} fontSize={fontSize} fontWeight={fontWeight} htmlFor={name}>
				{title}
				<S.CheckTumb background={background} color={color} />
			</S.Label>
		</>
	);
};
